import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
})
export class IconComponent implements OnInit {
  @Input() icon = '';
  @Input() isVerticalNav?: boolean;
  @Input() isMenuActive = false;
  @Input() isFocused = false;
  @Input() isSelected = false;
  @Input() isFocusableElement = false;
  constructor() {}

  ngOnInit(): void {}

  get cssClass() {
    if (this.isVerticalNav && this.icon.includes('my-aha-profile-icon-')) {
      return `icon-${this.icon.toLowerCase()}-nav`;
    }

    if (this.isVerticalNav !== undefined) {
      // specific to vertical navbar
      if (this.isFocused && this.isMenuActive) {
        return `icon-${this.icon}-focused`;
      }
    }

    if (this.isFocused) {
      return `icon-${this.icon}-focused`;
    }

    // 🔹 Prioritize selected state
    if (this.isSelected) {
      return `icon-${this.icon}-selected`;
    }

    // 🔸 Then check active
    if (this.isMenuActive) {
      return `icon-${this.icon}-active`;
    }

    return `icon-${this.icon}`;
  }
}
